if (!customElements.get('custom-fieldset')) {
	class CustomFieldset extends HTMLElement {
		constructor() {
			super();
			this.radioButtons = this.querySelectorAll('input[type="radio"]');
			this.propertyChange = this.hasAttribute('data-product-property');
			this.propertyChangeInput = false;
			this.selectedOption = this.querySelector('input[type="radio"]:checked');
			// this.propertyChangeImage = this.hasAttribute('data-product-property-change-images');

			if (this.propertyChange) {
				this.propertyChangeInput = this.querySelector(`input[name="properties[${this.getAttribute('data-product-property-name')}]"]`);
				const formId = this.getAttribute('data-product-form-id');

				if (this.propertyChangeInput) {
					const clonedInput = this.propertyChangeInput.cloneNode(true);
					const form = document.getElementById(formId);
					const input = form.querySelector(`input[name="properties[${this.getAttribute('data-product-property-name')}]"]`);

					if (input) {
						input.remove();
					}

					form.appendChild(clonedInput);
				}

				// if (this.propertyChangeImage && formId) {
				// 	this.handleImages();
				// }
			}

			this.init();
		}

		init() {
			if (this.propertyChange && this.propertyChangeInput) {
				this.propertyChangeInput.value = this.selectedOption.value;
				const formId = this.getAttribute('data-product-form-id');
				const form = document.getElementById(formId);
				const input = form.querySelector(`input[name="properties[${this.getAttribute('data-product-property-name')}]"]`);

				if (input) {
					input.value = this.selectedOption.value;
				} else {
					const clonedInput = this.propertyChangeInput.cloneNode(true);
					form.appendChild(clonedInput);
				}
			}
			this.radioButtons.forEach((radio) => {
				radio.addEventListener('change', this.handleRadioChange.bind(this));
			});
		}

		handleRadioChange(event) {
			this.selectedOption = event.target;

			if (this.propertyChange && this.propertyChangeInput) {
				this.propertyChangeInput.value = this.selectedOption.value;
				const formId = this.getAttribute('data-product-form-id');
				const form = document.getElementById(formId);
				const input = form.querySelector(`input[name="properties[${this.getAttribute('data-product-property-name')}]"]`);

				if (input) {
					input.value = this.selectedOption.value;
				} else {
					const clonedInput = this.propertyChangeInput.cloneNode(true);
					form.appendChild(clonedInput);
				}
			}

			// if (this.propertyChangeImage) {
			// 	this.handleImages();
			// }

			this.updateLabel(this.selectedOption);
		}

		handleImages() {
			const formId = this.getAttribute('data-product-form-id');
			const form = document.getElementById(formId);

			if (!form) return;
			
			const propertiesOfForm = form.querySelectorAll('input[name^="properties["]');

			let altOfTheImage = [];

			propertiesOfForm.forEach((property) => {
				altOfTheImage.push(property.value.toLowerCase().trim());
				altOfTheImage.push(property.dataset.name.toLowerCase().trim());
			});

			altOfTheImage = altOfTheImage.map((el) => el.split(' ')).flat();

			const allThumbnails = this.closest('.shopify-section').querySelectorAll('.thumbnail--media-image img');
			const allThumbnailsAlt = Array.from(allThumbnails).map((thumbnail) => thumbnail.alt);
			let firstClicked = false;

			allThumbnailsAlt.forEach((thumbnailAlt, index) => {
				if (firstClicked == true || thumbnailAlt == '') {
					return;
				}

				if (altOfTheImage.every((alt) => thumbnailAlt.toLowerCase().trim().includes(alt))) {
					if (allThumbnails[index].offsetParent !== null) {
						allThumbnails[index].click();
						firstClicked = true;
					}
				}
			});
		}

		updateLabel(selectedOption) {
			const label = selectedOption.nextElementSibling.querySelector('.color-label');
			const colorLabel = this.querySelector('.js-color-text');
			if (label && colorLabel) {
				colorLabel.textContent = label.dataset.label;
			} else {
				console.log("Label elements not found");
			}
		}
	}

	customElements.define('custom-fieldset', CustomFieldset);
}
